import styled from "styled-components";
import Button from "../../Atoms/Button";
import { tokens, media } from "../../../design/tokens";

/*
 * Carrinho — SOMENTE ESTILO. O index.tsx nao foi tocado, entao todos os
 * ganchos de classe usados por ele continuam existindo aqui
 * (.pix-btn, .pix2-btn, .boleto-btn, .cartao-btn, .cartao2-btn,
 * .apply-coupon-btn, .total, .btns, .courseContent, .oldPrice, .discount,
 * .valorcartaoparcelado, .nameWithCoupon, .bold, .close_btn, .safari_only).
 *
 * O painel era `background: #fff` deslizando por cima de um app preto — a
 * quebra visual mais forte que restava no produto, e o "Don't" literal da
 * Regra do Palco em DESIGN.md. Agora e o degrau tonal do sistema.
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 0;
  overflow: hidden;

  position: absolute;
  right: 0;

  background: ${tokens.color.cardCharcoal};
  border-radius: ${tokens.radius.sm} 0 0 ${tokens.radius.sm};
  /* Separa o painel do palco sem depender so do tom. */
  box-shadow: ${tokens.shadow.imageSeat};

  z-index: ${tokens.zIndex.modal};

  transition: all 0.3s ease-out 0s;

  &.active {
    max-width: 500px;
    width: 500px;

    ${media.upTo(tokens.breakpoint.sm)} {
      min-height: 100vh;
      height: auto;
      max-width: 100%;
      width: 100%;

      overflow-y: auto;
    }
  }
`;

/*
 * O cabecalho era uma faixa inteira de Ouro de Marquise. Ouro no sistema e
 * para "o que precisa ser notado" — preco, progresso, acao primaria — e uma
 * barra de 500x40px nao e nenhum dos tres; gastava o acento antes de o
 * usuario chegar no preco. Agora e escuro, com o ouro guardado para o valor
 * e para o botao que fecha a compra.
 */
export const TitleSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  height: 56px;
  width: 100%;

  background: ${tokens.color.cardCharcoal};
  border-bottom: 1px solid ${tokens.color.fieldSlate};
  border-radius: ${tokens.radius.sm} 0 0 0;

  color: ${tokens.color.textWhite};

  font-family: ${tokens.font.label.family};
  font-size: 1rem;
  font-weight: 600;

  .close_btn {
    position: absolute;
    left: ${tokens.space.lg};
    color: ${tokens.color.textWhite};

    transition: filter 0.2s, color 0.2s;

    &:hover {
      filter: opacity(0.6);
      cursor: pointer;
    }
  }
`;

/* O painel encosta na borda direita da janela, entao a goteira lateral e a
   unica coisa separando o texto do fim da tela: 16px deixava o preco
   raspando a borda. */
export const ItensSection = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${tokens.space.lg} ${tokens.space.xl};
  gap: ${tokens.space.md};

  /* Esta e a unica secao que cede altura: ela ocupa o que sobra e rola por
     dentro. Cupom e area de acao sao flex-shrink: 0. */
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const CouponContainer = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  border: solid 1px ${tokens.color.fieldSlate};
  border-radius: ${tokens.radius.sm};

  margin: 0 ${tokens.space.lg};
  width: calc(100% - ${tokens.space.xl} * 2);

  padding: ${tokens.space.lg};

  /* Mesma razao do ButtonSection: nao pode ser espremido em janela baixa. */
  flex-shrink: 0;

  > p {
    white-space: nowrap;
    display: block;
    text-overflow: ellipsis;

    color: ${tokens.color.textMist};
    margin-right: ${tokens.space.lg};
    text-align: left;
    font-family: ${tokens.font.body.family};
    font-size: ${tokens.font.body.size};
  }

  button {
    width: 80px;
    height: 36px;
    margin: 0;
    margin-left: auto;

    border-radius: ${tokens.radius.sm};
  }

  /*
   * O campo de cupom e um <input> cru, sem classe e sem passar pelo atomo
   * Input — herdava o estilo padrao do navegador: fundo branco, texto preto e
   * borda inset. Dentro de um painel escuro virava um retangulo aceso. Como
   * nao posso trocar o elemento (isso e index.tsx), alinho o cru ao sistema.
   */
  input {
    flex: 1;
    min-width: 0;
    height: 36px;
    padding: 0 ${tokens.space.md};

    background: ${tokens.color.fieldSlate};
    border: 1px solid ${tokens.color.fieldSlate};
    border-radius: ${tokens.radius.sm};

    color: ${tokens.color.textWhite};
    font-family: ${tokens.font.body.family};
    font-size: ${tokens.font.body.size};

    transition: border-color 0.2s;

    &::placeholder {
      color: ${tokens.color.textMist};
    }

    &:focus {
      border-color: ${tokens.color.focusAmber};
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${tokens.color.focusAmber};
      outline-offset: 2px;
    }
  }

  ${media.upTo(tokens.breakpoint.sm)} {
    flex-wrap: wrap;
    justify-content: space-between;
    padding: ${tokens.space.md};

    p {
      min-width: 100%;
      padding: 0;
      margin: 0 0 ${tokens.space.sm};
    }

    input {
      margin: 0;
      height: 40px;
      max-height: 40px;
      width: 65%;
    }
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: ${tokens.color.textWhite};
  font-family: ${tokens.font.body.family};

  p {
    margin: 0;
  }

  span {
    text-align: right;
    margin: 0;
  }

  .nameWithCoupon {
    display: flex;
    flex-direction: column;

    > strong {
      font-size: ${tokens.font.caption.size};
      color: ${tokens.color.textAsh};
    }
  }

  /* Preco antigo e metadado, nao alerta: cinza de apoio, nao um cinza claro
     de tema claro que so existia porque o painel era branco. */
  .oldPrice {
    color: ${tokens.color.textAsh};
    text-decoration: line-through;
  }

  .valorcartaoparcelado {
    color: ${tokens.color.textAsh};
    font-size: ${tokens.font.caption.size};
  }

  /* Era verde #00b431 — um terceiro acento, que a Regra da Voz Unica proibe.
     Desconto e exatamente "o que precisa ser notado": vai no ouro. */
  .discount {
    color: ${tokens.color.marqueeGold};
    font-size: ${tokens.font.caption.size};
    font-weight: 600;
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  /* Folga extra embaixo: sem ela o ultimo metodo (PIX) encostava na borda da
     janela — 16px de respiro num painel de altura 100vh. */
  padding: ${tokens.space.lg} ${tokens.space.lg} ${tokens.space.xl};
  width: 100%;

  margin-top: auto;

  /*
   * O DEFEITO: sem isto o flex-shrink padrao (1) deixava esta secao ser
   * espremida quando a janela era mais baixa que o conteudo do painel — e o
   * que some primeiro e o ultimo botao da pilha, o PIX. A lista de itens
   * acima ja rola sozinha (ItensSection tem overflow-y: auto), entao quem
   * tem de ceder altura e ela, nunca a area de acao.
   */
  flex-shrink: 0;

  color: ${tokens.color.textWhite};
  font-family: ${tokens.font.body.family};

  .courseContent {
    ${media.upTo(tokens.breakpoint.sm)} {
      display: flex;
      margin-left: 10px;
      flex-direction: column;

      & > div {
        display: flex;
        flex-direction: row;
        align-items: end;

        .whitecolor {
          color: ${tokens.color.textWhite};
        }
      }
    }
  }

  .total {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: ${tokens.space.lg} 0 ${tokens.space.xl};
    font-weight: 600;

    span {
      font-weight: 600;
    }

    p {
      font-size: ${tokens.font.caption.size};
      color: ${tokens.color.textAsh};
    }

    strong {
      font-size: 1rem;
    }

    /* O valor total e o unico numero da tela que precisa ser notado. */
    .bold {
      text-align: right;
      font-weight: 600;
      font-size: 1.125rem;
      color: ${tokens.color.marqueeGold};
    }

    .oldPrice {
      color: ${tokens.color.textAsh};
      text-decoration: line-through;
    }
  }

  /*
   * Os tres metodos empilham em vez de dividir a largura.
   * Lado a lado num painel de 500px cada um ficava com ~150px e o rotulo
   * mais longo era cortado no meio ("CARTÃO DE ..."). Empilhado, cabe
   * inteiro e cada alvo de toque fica confortavel.
   */
  .btns {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${tokens.space.sm};
  }

  ${media.upTo(tokens.breakpoint.sm)} {
    margin-top: 0;

    .btns {
      margin-bottom: 7rem;
    }
  }

  @media not all and (min-resolution: 0.001dpcm) {
    ${media.upTo(tokens.breakpoint.sm)} {
      .safari_only {
        .btns {
          margin-bottom: 4rem;
        }
      }
    }
  }
`;

/*
 * Metodos de pagamento.
 *
 * Eram tres cores sem nenhuma relacao com a marca nem entre si: PIX em
 * #49baae (o ciano vestigial que o DESIGN.md manda nao usar), boleto em
 * #646978 e cartao em #ff6600. Tres acentos concorrentes numa tela so.
 *
 * Agora os tres tem o mesmo tratamento — contorno em ouro sobre fundo
 * translucido, que e a variante "contrast" ja documentada do sistema. Sao
 * alternativas equivalentes: nada justifica um chamar mais atencao que os
 * outros. Quem carrega o ouro solido e a acao que fecha a compra.
 */
const paymentMethod = `
  width: 100%;
  font-size: ${tokens.font.body.size};

  color: ${tokens.color.marqueeGold};
  background: rgba(254, 212, 74, 0.14);
  border: 2px solid ${tokens.color.marqueeGold};

  &:hover {
    background: rgba(254, 212, 74, 0.24);
  }
`;

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 40%;

  svg {
    color: currentColor;
  }

  img {
    width: 20px;
    height: 20px;
  }

  p {
    margin-left: ${tokens.space.sm};
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }

  /* filter: invert(1) existia para escurecer icones sobre fundo colorido
     claro. Sobre o painel escuro o icone precisa ser claro, entao a inversao
     sai — menos um efeito compensando outro. */
  &.pix-btn,
  &.pix2-btn,
  &.boleto-btn,
  &.cartao-btn,
  &.cartao2-btn {
    ${paymentMethod}

    img {
      filter: none;
    }
  }

  &.boleto-btn img {
    width: 28px;
    height: 20px;
  }

  &.cartao-btn img,
  &.cartao2-btn img {
    width: 25px;
    height: 18px;
  }

  /*
   * "Aplicar cupom" vinha verde #04b530 — o index.tsx passa state="success"
   * ao Button, e verde nao existe na paleta deste produto (terceiro acento,
   * proibido pela Regra da Voz Unica).
   *
   * Fica deliberadamente discreto, e nao em ouro: as acoes que importam nesta
   * tela sao os tres metodos de pagamento. Um cupom e ajuda, nao o objetivo —
   * se ele brilhar mais que "PIX", a tela aponta para o lugar errado.
   * Seletor duplicado para vencer a regra de state sem recorrer a !important.
   */
  &&.apply-coupon-btn {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: ${tokens.space.lg};

    background: transparent;
    border: 1px solid ${tokens.color.fieldSlate};
    color: ${tokens.color.textMist};

    transition: border-color 0.2s, color 0.2s;

    &:hover {
      border-color: ${tokens.color.marqueeGold};
      color: ${tokens.color.marqueeGold};
    }

    p {
      margin: 0;
    }

    svg {
      color: currentColor;
      font-weight: bold;
    }
  }

  @media (max-width: 1200px) {
    padding: 0 ${tokens.space.md};

    &.apply-coupon-btn {
      width: 80px;
      height: 36px;
      margin-left: ${tokens.space.md};

      p {
        display: none;
      }

      svg {
        width: 70%;
        height: 70%;
      }
    }
  }
`;
